export default __webpack_public_path__ + "194d20b03659812d87b5302c7d084a36.jpg";